import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "w-full bg-brand-secondary text-center py-2"
}
const _hoisted_3 = ["innerHTML"]




export default /*@__PURE__*/_defineComponent({
  __name: 'HeroBanner',
  props: {
    announcement: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.announcement)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", {
            class: "container mx-auto text-white",
            innerHTML: _ctx.announcement
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})